import { createUrqlClient } from '@/utils/urql-client';

export const urqlClient = createUrqlClient();
